import { deviceType } from '@/utils/common'
import ReferralIndex from './common/referral/index'
import PcReferralsLayout from './pc/referrals/layout.vue'
import MobileReferralsLayout from './mobile/referrals/layout.vue'
import ReferralChainIndex from './common/referralChain/index.vue'
import ReferralChainPotential from './common/referralChain/potential.vue'
import ReferralChainApplied from './common/referralChain/appliedPotential.vue'
import ReferralChainHidden from './common/referralChain/hiddenPotential.vue'
import PcDashboard from './pc/dashboard.vue'
import MobileDashboard from './mobile/dashboard.vue'
import PcLeaderBoard from './pc/leaderboard.vue'
import MobileLeaderBoard from './mobile/leaderboard.vue'

const basePath = '/recruiting/personal/referral'

const rewardsRoute = {
  name: 'personalReferralRewards',
  path: `${basePath}/rewards`,
  component: ReferralIndex,
  meta: {
    titleI18nKey: 'personal.referrals.rewards.title',
    menuI18nKey: 'personal.referrals.rewards.menu'
  }
}

const leadsRoute = {
  name: 'personalReferralLeads',
  path: `${basePath}/leads`,
  redirect: `${basePath}/leads/potential`,
  component: ReferralChainIndex,
  meta: {
    titleI18nKey: 'personal.referrals.leads.title.index',
    menuI18nKey: 'personal.referrals.leads.menu.index'
  },
  children: [
    {
      name: 'personalReferralPotentialLeads',
      path: `${basePath}/leads/potential`,
      component: ReferralChainPotential,
      meta: {
        titleI18nKey: 'personal.referrals.leads.title.potential',
        menuI18nKey: 'personal.referrals.leads.menu.potential'
      }
    },
    {
      name: 'personalReferralAppliedLeads',
      path: `${basePath}/leads/applied`,
      component: ReferralChainApplied,
      meta: {
        titleI18nKey: 'personal.referrals.leads.title.applied',
        menuI18nKey: 'personal.referrals.leads.menu.applied'
      }
    },
    {
      name: 'personalReferralHideLeads',
      path: `${basePath}/leads/hidden`,
      component: ReferralChainHidden,
      meta: {
        titleI18nKey: 'personal.referrals.leads.title.hidden',
        menuI18nKey: 'personal.referrals.leads.menu.hidden'
      }
    }
  ]
}

const leaderBoardRoute = {
  name: 'personalReferralLeaderBoard',
  path: `${basePath}/leader-board`,
  component: deviceType.isPc ? PcLeaderBoard : MobileLeaderBoard,
  meta: {
    titleI18nKey: 'personal.referrals.leaderboard.title',
    menuI18nKey: 'personal.referrals.leaderboard.menu'
  }
}

const dashboardRoute = {
  name: 'personalReferralDashboard',
  path: `${basePath}/dashboard`,
  component: deviceType.isPc ? PcDashboard : MobileDashboard,
  meta: {
    titleI18nKey: 'personal.referrals.dashboard.title',
    menuI18nKey: 'personal.referrals.dashboard.menu'
  }
}

export default {
  name: 'personalReferralsIndex',
  path: `${basePath}`,
  component: deviceType.isPc ? PcReferralsLayout : MobileReferralsLayout,
  redirect: leadsRoute.path,
  meta: {
    isInclude: true,
    mobileHomeMenu: {
      iconClass: 'iconreferrals',
      nameI18nKey: 'personal.referrals.homeMenu.name',
      descI18nKey: 'personal.referrals.homeMenu.desc'
    }
  },
  children: [
    rewardsRoute,
    leadsRoute,
    leaderBoardRoute,
    dashboardRoute
  ]
}

export { rewardsRoute, leadsRoute, leaderBoardRoute, dashboardRoute }
